define.alias("shared/components/shared/typeform-survey-trigger", "media/components/shared/typeform-survey-trigger");